<template>
    <div class="menu--actions">
        <nav>
            <ul>
                <li :class="cartUpdate">
                    <Link :href="$$route('checkout.cart')" class="btn btn--secondary btn--icon" :title="this.$gettext('Warenkorb')">
                        <svg-vue icon="shopping-cart" class="icon"></svg-vue>
                        <translate>Warenkorb</translate>
                    </Link>
                    <span class="cart-contents" v-if="cartCount">{{ cartContent }}</span>
                </li>
                <li>
                    <Link :href="$$route('ask-for-quote.1')" class="btn btn--secondary btn--icon" :title="this.$gettext('Anfrage einstellen')"><svg-vue icon="file-blank-add-plus" class="icon"></svg-vue><translate>Anfrage einstellen</translate></Link>
                </li>
                <li>
                    <Link :href="$$route('search')" class="btn btn--secondary btn--icon" :title="this.$gettext('Kontosuche')"><svg-vue icon="documents-file-search" class="icon"></svg-vue><translate>Kontosuche</translate></Link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import {router} from '@inertiajs/vue3';

export default {
    name: 'MenuActions',
    computed: {
        cartCount() {
            return this.$page.props.cartCount > 0;
        },
        cartContent() {
            return this.$page.props.cartCount === 1 ? '1 ' + this.$gettext('Bauteil') : this.$page.props.cartCount + ' ' + this.$gettext('Bauteile');
        },
        cartUpdate() {
            // console.log(Inertia.restore('cardCount'));
            const updateClass = router.restore('cardCount') !== this.$page.props.cartCount ? 'cart-update' : '';

            router.remember(this.$page.props.cartCount, 'cardCount');

            return updateClass;
        }
    },
};
</script>
